export default __webpack_public_path__ + "static/media/ultimo-presupuesto-modal.f6df60d4.png";